import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=fbe582cc&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=fbe582cc&prod&scoped=true&lang=scss"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=fbe582cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe582cc",
  null
  
)

export default component.exports